import { Dispatch } from "redux";
import {
    setServiceAssertionPerformanceReferenceData,
    setServiceAssertionPerformanceReferenceDataLoading
} from "@redux/actions/service-assertion-performance-actions";
import { getServiceAssertionPerformanceReferenceDataRequest } from "@requests/reports/get-service-assertion-performance-reference-data";
import { logAndDisplayErrorModal } from "@utils/app-alert-util";
import { resources } from "@constants/hardcoded-strings";

export const getServiceAssertionPerformanceReferenceDataReduxRequest = (dispatch: Dispatch) => async () => {
    dispatch(setServiceAssertionPerformanceReferenceDataLoading(true));
    const { data, error } = await getServiceAssertionPerformanceReferenceDataRequest();
    if (data) {
        dispatch(setServiceAssertionPerformanceReferenceData(data));
    } else {
        if (error) {
            logAndDisplayErrorModal(
                dispatch,
                error,
                resources.requests.referenceData.error.title,
                resources.requests.referenceData.error.message
            );
        }
        dispatch(setServiceAssertionPerformanceReferenceDataLoading(false));
    }
};